/**
 * Tasks summary card — pie + done / pending + percent complete.
 */
import React from 'react';
import { Card } from '../ui/card';
import { CheckCircle } from 'iconoir-react';
import SummaryPie from './SummaryPie';

export default function TasksSummaryCard({ summary }) {
  const total = summary?.total_tasks || 0;
  const done = summary?.completed || 0;
  const pending = summary?.pending || 0;
  const pct = total > 0 ? ((done / total) * 100).toFixed(0) : '0';

  return (
    <Card className="card-surface p-6" data-testid="checklist-stat-card">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif text-xl text-charcoal">Tasks</h2>
        <CheckCircle className="w-5 h-5 text-muted" strokeWidth={1.5} />
      </div>
      <div className="flex items-center gap-4">
        <SummaryPie filled={done} remaining={pending} filledColor="#9D8089" />
        <div className="flex-1 space-y-2">
          <div>
            <p className="text-xs text-muted">Total Tasks</p>
            <p className="font-mono text-xl text-charcoal">{total}</p>
          </div>
          <div className="flex gap-4">
            <div>
              <p className="text-xs text-muted">Done</p>
              <p className="font-mono text-sm text-moss">{done}</p>
            </div>
            <div>
              <p className="text-xs text-muted">Pending</p>
              <p className="font-mono text-sm text-ochre">{pending}</p>
            </div>
          </div>
          <p className="font-mono text-xs text-muted">{pct}% complete</p>
        </div>
      </div>
    </Card>
  );
}
